



import NewsPreviewComponent from "@/components/admin/news/newsPreviewComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "NewsPreviewPage",
  components: {
    NewsPreviewComponent,
  },
})
export default class NewsPreviewPage extends Vue {}
